import { Network } from '@tribeplatform/gql-client/types'
import { T } from '@tribeplatform/react-components/i18n'
import { Link } from '@tribeplatform/react-components/Link'
import { FormControl } from '@tribeplatform/react-ui-kit/FormControl'
import { HelperText } from '@tribeplatform/react-ui-kit/HelperText'

interface Props {
  domainInfo: Pick<Network, 'domain' | 'domainSubfolder'>
}

export const CurrentDomain = ({ domainInfo }: Props) => {
  const { domain, domainSubfolder } = domainInfo
  const isInstalledOnSubfolder = !!domainSubfolder

  return (
    <FormControl.InputCopy
      label={
        <T
          id="Admin.Domain.CurrentConfigs.PrimaryAddress"
          defaultMessage="Current address of your site"
        />
      }
      readOnly
      name="currentDomain"
      value={`https://${domain}`}
      className="font-mono"
      helperText={
        isInstalledOnSubfolder && (
          <HelperText status="info" highlighted>
            <T
              defaultMessage="Your site is only accessible via its alias, located at <link>{subfolder_address}</link>, since it is installed on a subfolder."
              id="Admin.Domain.CurrentConfigs.SubfolderAddress"
              values={{
                subfolder_address: `https://${domainSubfolder}`,
                link: chunks => {
                  return (
                    <Link variant="accent" className="font-mono" to={chunks}>
                      {chunks}
                    </Link>
                  )
                },
              }}
            />
          </HelperText>
        )
      }
    />
  )
}
